import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useParams, Navigate } from 'react-router-dom';
import { get } from 'lodash';
import { useSweeps } from '../../hooks/useSweeps';
import { getEntryBySweepId } from '../../api/sweepstakeApi';
import { SweepContext } from '../../hooks/useSweep';
import { EntryContext, DEFAULT_ENTRY } from '../../hooks/useEntry';
import { useAuth } from '../../hooks/useAuth';
import { useError } from '../../hooks/useError';
import { PromotionsProvider } from '../../hooks/usePromotions';
import Loading from '../Loading';
import { Layout } from '../Layout';

const SweepLayout = ({ children }) => {
    const { sweepId } = useParams();
    const { findSweepById, loading: sweepsLoading } = useSweeps();
    const { authStore } = useAuth();
    const { setError } = useError();

    const sweep = findSweepById(sweepId);
    const [entry, setEntry] = useState(DEFAULT_ENTRY);

    useEffect(() => {
        if (!authStore.loggedIn || !sweep) {
            return;
        }

        getEntryBySweepId({
            sweepId: sweep.sweepId,
            productToken: authStore.productToken
        }).then(({ data, errorMessage }) => {
            if (errorMessage) {
                setError(errorMessage);
                return;
            }
            if (data) {
                setEntry({
                    hasEntered: data.hasEntered,
                    id: get(data, 'selection.id', null),
                    name: get(data, 'selection.name', null),
                    metaData: get(data, 'selection.metaData', {})
                });
            }
        });
    }, [sweep, authStore.loggedIn, authStore.productToken, setError]);

    if (sweepsLoading) {
        return (
            <Layout
                loggedIn={authStore.loggedIn}
                userName={authStore.user.given_name}
            >
                <Loading heading="LOADING" />
            </Layout>
        );
    }

    if (
        !sweep ||
        sweep.event?.status === 'abandoned' ||
        sweep.event?.status === 'archived'
    ) {
        return <Navigate to="/" replace />;
    }

    return (
        <SweepContext.Provider value={{ sweep }}>
            <PromotionsProvider sweepId={sweep.sweepId}>
                <EntryContext.Provider value={{ entry, setEntry }}>
                    {children}
                </EntryContext.Provider>
            </PromotionsProvider>
        </SweepContext.Provider>
    );
};

SweepLayout.propTypes = {
    children: PropTypes.node.isRequired
};

export default SweepLayout;
